import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Konversi Tanggal dari Masehi ke Hijriah";
const DESCRIPTION =
  "Konversi tanggal dari Masehi ke Hijriah dengan memasukkan tanggal dalam Masehi dan mengetahui padanannya dalam Hijriah menggunakan konverter tanggal elektronik";
const KEYWORDS =
  "konversi tanggal, Masehi, Hijriah, memasukkan tanggal, konverter tanggal elektronik, padanan, dalam Masehi, dalam Hijriah, mengetahui, konversi tanggal Masehi ke Hijriah, elektronik, konversi tanggal";
const OG_URL = "https://do-calculate.com/calculator/id/gregorian_to_hijri";

// Updated Month List with names and numbers
const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];

function ConversionToHijri() {
  const [dateInputs, setDateInputs] = useState({ day: "", month: "", year: "" });
  const [hijriDate, setHijriDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToHijri = () => {
    const { day, month, year } = dateInputs;

    if (!day || !month || !year) {
      setShowError(true);
      setHijriDate("");
      return;
    }

    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const isValidDate = moment(formattedDate, "YYYY-MM-DD", true).isValid();

    if (isValidDate && parseInt(year) > 1937) {
      const convertedDate = moment(formattedDate, "YYYY-MM-DD").format("iYYYY-iM-iD");
      setHijriDate(convertedDate);
      setShowError(false);
    } else {
      setHijriDate("");
      setShowError(true);
    }
  };

  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light ">
            <div className="row ">
              <div className="p-3">
                <p>
                  Kalkulator online ini menyediakan cara mudah untuk mengkonversi tanggal dari
                  kalender Masehi ke Hijriah. Cukup, pengguna menentukan arah
                  konversi dan memasukkan tanggal Masehi yang ingin dikonversi. Setelah itu,
                  kalkulator melakukan proses secara otomatis dan menyajikan tanggal yang dikonversi
                  dalam kalender Hijriah. Hasilnya ditampilkan dalam dua cara: pertama dalam format numerik,
                  dan kedua dengan menyajikan hari, bulan, dan tahun secara detail. Kalkulator ini
                  memungkinkan pengguna mendapatkan dengan cepat dan akurat tanggal yang dikonversi antara
                  kalender Masehi dan Hijriah, sehingga memudahkan pengaturan waktu dan acara dalam
                  kehidupan sehari-hari.
                </p>
                <br />
                Anda dapat melalui kalkulator ini memasukkan tanggal dalam format Masehi dan kalkulator akan
                melakukan proses konversi tanggal yang dimasukkan ke padanannya dalam tanggal Hijriah
                Arab menurut kalender Ummul Qura
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row ">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Konversi Tanggal dari Masehi ke Hijriah
                </div>
                <div>
                  <label
                    style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Masukkan Tanggal Masehi
                  </label>
                </div>

                {/* Day, Month, Year Inputs in one row */}
                <div className="row">
                  <div className="col-md-4">
                    <label style={{ fontSize: "14px" }}>Hari</label>
                    <select
                      className="form-control"
                      value={dateInputs.day}
                      onChange={(e) => setDateInputs({ ...dateInputs, day: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Hari</option>
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label style={{ fontSize: "14px" }}>Bulan</label>
                    <select
                      className="form-control"
                      value={dateInputs.month}
                      onChange={(e) => setDateInputs({ ...dateInputs, month: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Bulan</option>
                      {GREGORIAN_MONTHS.map((month, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1} - {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label style={{ fontSize: "14px" }}>Tahun</label>
                    <select
                      className="form-control"
                      value={dateInputs.year}
                      onChange={(e) => setDateInputs({ ...dateInputs, year: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Tahun</option>
                      {Array.from(
                        { length: new Date().getFullYear() - 1936 },
                        (_, i) => new Date().getFullYear() - i
                      ).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col text-center">
                    <br />
                    <button
                      className="btn btn-success"
                      onClick={convertToHijri}
                      style={{
                        fontSize: "17px",
                        marginTop: "25px",
                        marginBottom: "10px",
                        padding: "10px 40px"
                      }}
                    >
                      Hitung
                    </button>
                  </div>
                  <div className="row">
                    {showError && (
                      <p style={{ color: "red", textAlign: "center" }}>
                        Harap masukkan tanggal yang valid antara 1938 dan tanggal saat ini
                      </p>
                    )}
                    <div className="col">
                      {hijriDate && !showError && (
                        <Fragment>
                          <hr style={{ margin: "1rem 0" }} />
                          <div className="table-responsive" style={{ marginBottom: "15px" }}>
                            <table className="table table-bordered" style={{ marginBottom: "0" }}>
                              <thead style={{ backgroundColor: "#4caf50", color: "white" }}>
                                <tr>
                                  <th style={{ textAlign: "center", fontSize: "20px", fontWeight: "normal" }}>
                                    Tanggal yang Dimasukkan
                                  </th>
                                  <th style={{ textAlign: "center", fontSize: "20px", fontWeight: "normal" }}>
                                    Bertepatan dengan Tanggal Hijriah
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ textAlign: "center", fontSize: "18px" }}>
                                    {`${dateInputs.day}-${dateInputs.month}-${dateInputs.year}`}
                                   </td>
                                  <td style={{ textAlign: "center", fontSize: "18px" }}>
                                    {hijriDate}
                                   </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <div className="row">
              <RelatedLinks />
              <br />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Konversi Tanggal Masehi ke Hijriah
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Konversi Tanggal Masehi ke Hijriah Online
                  </h2>{" "}
                </u>
                <br />
                <p>
                  Kalkulator online dianggap sebagai cara efektif untuk mengkonversi tanggal dari
                  kalender Masehi ke Hijriah. Misalnya, aplikasi dapat mengkonversi tanggal penerbitan paspor dari tanggal Masehi, di mana hari ditentukan dua puluh, bulan ketiga, dan tahun dua ribu dua puluh, untuk menampilkan tanggal yang dikonversi dalam kalender Hijriah. Dalam konteks lain, aplikasi digunakan untuk mencatat tanggal kedaluwarsa kartu kredit, di mana hari kelima belas, bulan kesepuluh, dan tahun dua ribu dua puluh dalam tanggal Masehi. Konversi tanggal online memungkinkan pengaturan waktu dan janji dengan mudah, baik untuk tujuan perjalanan atau keuangan, dengan kemampuan untuk mengakses hasil secara cepat dan akurat kapan saja dan dari mana saja di dunia.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Langkah-langkah Konversi Tanggal</h2>
                </u>
                <br />
                <p>
                  Konverter tanggal dari Hijriah ke Masehi dan sebaliknya dengan cara yang benar Insya Allah, cukup pilih metode konversi, misalnya jika Anda ingin mengkonversi tanggal Hijriah ke tanggal Masehi cukup tekan kalimat konversi tanggal Hijriah, lalu pilih hari, bulan, dan tahun lalu konversi, setelah itu situs akan secara otomatis menentukan tanggal yang benar sesuai kalender yang Anda pilih dengan mengubah negara atau memilih kalender Ummul Qura, dan hal yang sama berlaku untuk konversi tanggal dari Masehi ke Hijriah dengan mengikuti langkah-langkah sebelumnya.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Aplikasi Praktis dan Contoh Konversi Tanggal dari Kalender Masehi ke Hijriah{" "}
                  </h2>
                </u>
                <br />
                <p>
                  Aplikasi efektif untuk konversi tanggal dari kalender Masehi ke Hijriah, di mana contoh menampilkan tanggal lahir seseorang yang lahir di negara asing pada tanggal 15/9/2020. Tanggal ini perlu dikonversi ke kalender Hijriah untuk mencatat kelahiran di Kerajaan Arab Saudi, misalnya. Dengan memasukkan hari 15, bulan 9, dan tahun 2020 ke dalam sistem konversi, tanggal yang dikonversi muncul dalam berbagai format seperti 1442-01-28 atau 28 Muharram 1442, dan dengan demikian pekerjaan selesai dengan sukses.
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}

export default ConversionToHijri;